import ChatIcon from '@/public/images/dashboard/chat.svg';
import DashboardEmptyStateCard from '@/components/Dashboard/DashboardEmptyStateCard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';

export default function InquiriesReceivedEmptyState() {
  return (
    <DashboardEmptyStateCard
      icon={ChatIcon}
      title={Trans(translations, 'HereYouWillSeeWhereYourQueriesCameFrom')}
      description={Trans(
        translations,
        'MakeSureAllYourContactsHaveTheirSourceTag'
      )}
    />
  );
}
